/* Drawer behavior. Deliberately not a <details> element: this needs to close
   on Escape and on an outside tap, which <details> does not do on its own,
   and the header is sticky so a drawer left open would follow the customer
   down the page. */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var toggle = header.querySelector('[data-menu-toggle]');
  var drawer = header.querySelector('[data-menu-drawer]');
  if (!toggle || !drawer) return;

  function setOpen(open) {
    drawer.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    setOpen(drawer.hidden);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !drawer.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });

  document.addEventListener('click', function (event) {
    if (!drawer.hidden && !header.contains(event.target)) setOpen(false);
  });

  /* Crossing the breakpoint with the drawer open would otherwise leave
     aria-expanded lying about a panel the desktop layout has hidden. */
  var wide = window.matchMedia('(min-width: 751px)');
  var onChange = function (event) {
    if (event.matches) setOpen(false);
  };
  if (wide.addEventListener) wide.addEventListener('change', onChange);
})();
